module.exports = __webpack_public_path__ + "static/media/dubdub.2ddcee61.jpeg";